export interface PdfSample {
  id: string;
  sellerCountry?: string;
  formName: string;
  kind: string;
  imageSrc: string;
  startPath: string;
}

function sellerSample(
  id: string,
  sellerCountry: string,
  formName: string,
  kind: string,
  imageSrc: string,
  startPath?: string,
): PdfSample {
  return {
    id,
    sellerCountry,
    formName,
    kind,
    imageSrc,
    startPath: startPath ?? `/app/new?sellerCountry=${sellerCountry}&type=invoice`,
  };
}

function standardSample(id: string, formName: string, kind: string, imageSrc: string): PdfSample {
  return {
    id,
    formName,
    kind,
    imageSrc,
    startPath: "/app/new?type=invoice",
  };
}

export const STANDARD_PDF_SAMPLE = standardSample(
  "standard-invoice-layout",
  "Standard invoice layout",
  "Shared standard PDF layout for general invoice files.",
  "/pdf-samples/template-standard.png",
);

export const PDF_SAMPLES: PdfSample[] = [
  sellerSample(
    "de-rechnung",
    "DE",
    "RECHNUNG",
    "Special Germany invoice: RECHNUNG plus XRechnung/ZUGFeRD options.",
    "/pdf-samples/de-rechnung.png",
  ),
  sellerSample(
    "fr-facture",
    "FR",
    "FACTURE",
    "Special France invoice: FACTURE plus Factur-X options.",
    "/pdf-samples/fr-facture.png",
  ),
  sellerSample(
    "jp-qualified-invoice",
    "JP",
    "Qualified invoice layout",
    "Registration-number and rate summary layout.",
    "/pdf-samples/jp-qualified.png",
  ),
  sellerSample(
    "kr-tax-invoice",
    "KR",
    "전자세금계산서 layout sample",
    "Korean electronic invoice companion PDF.",
    "/pdf-samples/kr-tax-invoice.png",
  ),
  sellerSample(
    "ph-vat-invoice",
    "PH",
    "VAT invoice layout",
    "Dedicated VAT invoice layout.",
    "/pdf-samples/ph-vat-invoice.png",
  ),
  sellerSample(
    "th-tax-invoice",
    "TH",
    "Tax invoice layout",
    "Thai/English invoice layout.",
    "/pdf-samples/th-tax-invoice.png",
  ),
  sellerSample(
    "ph-non-vat-invoice",
    "PH",
    "Non-VAT invoice layout",
    "Dedicated non-VAT invoice layout.",
    "/pdf-samples/ph-non-vat-invoice.png",
    "/app/new?sellerCountry=PH&type=invoice&taxMode=export",
  ),
  STANDARD_PDF_SAMPLE,
];

export function findPdfSampleForCountry(country: string | undefined): PdfSample | undefined {
  if (!country) return undefined;
  const normalized = country.toUpperCase();
  return PDF_SAMPLES.find((sample) => sample.sellerCountry === normalized) ?? STANDARD_PDF_SAMPLE;
}

export function findPdfSampleById(id: string | null | undefined): PdfSample | undefined {
  if (!id) return undefined;
  return PDF_SAMPLES.find((sample) => sample.id === id);
}
